import React from "react";
import axios from "axios";
import { url } from "../../../../../App";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import SingleDocModal from "../Modals/SingleDocModal";
import MultiDocsModal from "../Modals/MultiDocsModal";
import Cookies from "js-cookie";
// import { useNavigate } from "react-router";

const ViewBorrowerDoc = ({
  borrowerDetails,
  docName,
  title,
  closeModal,
  openLoader,
  closeLoader,
  modalType,
}) => {
  // const Navigate = useNavigate();
  console.log(borrowerDetails)

  const [modalData, setModalData] = useState({});

  const [modalArr, setModalArr] = useState([]);
  const [multiDocsModal, setMultiDocsModal] = useState(false);
 const token = Cookies.get('Token');
  const email = Cookies.get('Email');
  const [DeleteDocVisible, setDeleteDocVisible] = useState(false);
  const [DownloadDocVisible, setDownloadDocVisible] = useState(false);
  const [visible, setvisible] = useState(false);
  // const [token, setToken] = useState("");

  useEffect(() => {
    if (email === "rupesh.bishnoi@credin.in") {
      setvisible(true);
    } else {
      axios
        .post(url + "/user/getsingle", {
          token: token,
          email: email,
          useremail: email
        })
        .then((res) => {
          setDeleteDocVisible(res.data[0].permission.delete_borrower_document);
          setDownloadDocVisible(res.data[0].permission.download_borrower_document)
        })
        .catch((err) => {
          console.log(err);
          toast.error(err.message);
        })
    };
  }, [token, email]);

  //eslint-disable-next-line
  const viewBorrowerDocument = async () => {
    //TODO   setLoader(true);
    openLoader();
    if (!borrowerDetails[docName]) {
      closeLoader();
      return toast.error("Document does not Exist");
    }
    const req = {
      borrower_uniqueno: localStorage.getItem("uniqueID"),
      doc_name: borrowerDetails[docName].doc_name ?? docName,
      doc_type: borrowerDetails[docName]?.doc_type,
      token,
      email,
    };
    const res = await axios.post(url + "/borrower/viewdoc", req);
    // console.log(req, res.data);
    closeLoader();
    const downloadDocumentHandler = async () => {
      openLoader();
      let imgDoc;
      if (req.doc_type === "pdf") {
        imgDoc = "application";
      } else {
        imgDoc = "image";
      }
      openLoader();
      const downloadRes = await axios.post(url + "/borrower/downloaddoc", req);
      closeLoader();
      if (!downloadRes.data.auth) {
        toast.error(downloadRes.data.message);
      }
      const linkSource = `data:${imgDoc}/${req.doc_type};base64,${downloadRes.data.doc_base64}`;
      const downloadLink = document.createElement("a");
      console.log(req.doc_type);
      const fileName = `${req.borrower_uniqueno} ${title}.${req.doc_type}`;
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      closeLoader();
    };
    const deleteDocHandler = async () => {
      const text = `Are you sure you want to delete this document?`;
      if (!window.confirm(text)) {
        return;
      }
      openLoader();
      const deleteReq = {
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
        borrower_uniqueno: localStorage.getItem("uniqueID"),
        doc_arr: {
          location: borrowerDetails[docName].location,
          doc_type: borrowerDetails[docName].doc_type,
          doc_name: borrowerDetails[docName].doc_name,
        },
      };
      const deleteRes = await axios.post(
        url + "/borrower/deletedoc",
        deleteReq
      );
      closeLoader();
      if (!deleteRes.data.auth) {
        toast.error(deleteRes?.data.message);
        return;
      }
      toast.success(deleteRes.data.message);
      window.location.reload();
    };
    return {
      doc: res.data?.doc_base64,
      docType: req.doc_type,
      download: downloadDocumentHandler,
      delete: deleteDocHandler,
    };
  };

  const fetchMultiDocs = async () => {
    openLoader();
    try{
      const docsArray = await Promise.all(
        borrowerDetails[docName].map(async (data) => {
          const req = {
            borrower_uniqueno: localStorage.getItem("uniqueID"),
            doc_name: data?.doc_name ?? "",
            doc_type: data?.doc_type,
            token: Cookies.get("Token"),
            email: Cookies.get("Email"),
          };
          console.log(req)
          const res = await axios.post(url + "/borrower/viewdoc", req);
          // if (!res.data?.auth) {
          //   return;
          // }
          closeLoader();
          const downloadDocumentHandler = async () => {
            openLoader();
            let imgDoc;
            if (req.doc_type === "pdf") {
              imgDoc = "application";
            } else {
              imgDoc = "image";
            }
            const downloadRes = await axios.post(
              url + "/borrower/downloaddoc",
              req
            );
            closeLoader();
            if (!downloadRes.data.auth) {
              toast.error(downloadRes.data.message);
              closeLoader();
            }
            const linkSource = `data:${imgDoc}/${req.doc_type};base64,${downloadRes.data.doc_base64}`;
            const downloadLink = document.createElement("a");
            console.log(req.doc_type);
            const fileName = `${req.borrower_uniqueno} ${title}.${req.doc_type}`;
            console.log(title);
            console.log(fileName);
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
          };
          const deleteDocHandler = async () => {
            const text = `Are you sure you want to delete this document?`;
            if (!window.confirm(text)) {
              return;
            }
            openLoader();
            const deleteReq = {
              token: Cookies.get("Token"),
              email: Cookies.get("Email"),
              borrower_uniqueno: localStorage.getItem("uniqueID"),
              doc_arr: {
                location: data?.location,
                doc_type: data?.doc_type,
                doc_name: data?.doc_name,
              },
            };
            const deleteRes = await axios.post(
              url + "/borrower/deletedoc",
              deleteReq
            );
            closeLoader();
            if (!deleteRes.data.auth) {
              toast.error(deleteRes?.data.message);
              return;
            }
            toast.success(deleteRes.data.message);
            window.location.reload();
          };
          return {
            doc: res.data?.doc_base64,
            docType: req?.doc_type,
            download: downloadDocumentHandler,
            delete: deleteDocHandler,
          };
        })
      );
      setModalArr(docsArray);
    }catch(err){
      console.log(err)
      closeLoader()
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!Array.isArray(borrowerDetails[docName])) {
          setMultiDocsModal(false);
          const doc = await viewBorrowerDocument();
          setModalData(doc);
        } else {
          setMultiDocsModal(true);
          const doc = await fetchMultiDocs();
          setModalData(doc);
        }
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
    //eslint-disable-next-line
  }, []);

  console.log(modalData)

  return (
    <>
      {/* <ToastContainer /> */}
      {multiDocsModal ? (
        <MultiDocsModal
          title={title}
          closeModal={closeModal}
          array={modalArr}
          // download = {}
        />
      ) : (
        <SingleDocModal
          title={title}
          closeModal={closeModal}
          doc={modalData?.doc}
          docType={modalData?.docType}
          download={modalData?.download}
          delete={modalData.delete}
          isDownload={DownloadDocVisible || visible}
          isDelete={DeleteDocVisible || visible}
        />
      )}
    </>
  );
};

export default ViewBorrowerDoc;
